<template>
	<div>
		<InfiniteLoading
			ref="infiniteLoading"
			@infinite="infiniteHandler"
			:spinner="spinner"
		>
			<!-- 전부 조회 한 후 메시지 (출력 안함) -->
			<div slot="no-more"></div>
			<!-- 조회할 목록이 없을 경우 -->
			<div slot="no-results">조회 결과가 없습니다.</div>
		</InfiniteLoading>
	</div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';

export default {
	props: {
		spinner: {
			type: String,
			default: 'circles',
		},
	},
	components: {
		InfiniteLoading,
	},
	methods: {
		infiniteHandler(state) {
			this.$emit('infinite', state);
		},
		resetInfiniteLoading() {
			this.$refs.infiniteLoading.stateChanger.reset();
		},
	},
};
</script>
